module.exports = __webpack_public_path__ + "img/icon-trash-default.38c63677.svg";